/** Framed surface shared by leave forms, lists, filters, legends and calendars. */
export const leavePanelClassName =
  'rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm';

/** Same frame without inner padding, for tables that manage their own cells. */
export const leaveTableFrameClassName =
  'overflow-x-auto rounded-xl border border-border bg-card text-card-foreground shadow-sm';
